const GOOGLE_FONTS_ORIGIN = 'https://fonts.googleapis.com';

export const isSameOriginUrl = (url: string) => {
  if (!isValidUrl(url)) {
    return true;
  }

  const parsedUrl = new URL(url);
  return parsedUrl.origin === window.location.origin || parsedUrl.origin === GOOGLE_FONTS_ORIGIN;
};

export const isValidUrl = (url: string) => {
  try {
    new URL(url);
    return true;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (_) {
    return false;
  }
};
